import { useEffect } from 'react';

const RELOAD_DELAY_MS = 8000;

/**
 * Fallback do Sentry.ErrorBoundary em torno de <App />. Recarrega
 * automaticamente — a maioria das telas (Player, Jukebox) roda sem
 * ninguém por perto para clicar em nada, mesmo padrão do RAM watchdog
 * do Player (ver useHeartbeat.ts).
 */
export function CrashFallback() {
  useEffect(() => {
    const timer = setTimeout(() => window.location.reload(), RELOAD_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-black text-white p-8 text-center z-[9999]">
      <p className="text-lg font-bold">Algo deu errado.</p>
      <p className="text-white/60 text-sm">A página vai recarregar automaticamente.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-2 rounded-lg bg-white/10 px-4 py-2 text-sm font-semibold hover:bg-white/20"
      >
        Recarregar agora
      </button>
    </div>
  );
}
